import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type BrowserStatus = 'inControl' | 'live' | 'done';
/** `overlay` sits on the remote page, whose colors we don't control, so it fixes its own. */
type BrowserStatusTone = 'surface' | 'overlay';
const STATUS_TEXT: Record<BrowserStatusTone, Record<BrowserStatus, string>> = {
  surface: {
    inControl: 'text-accent',
    live: 'text-success',
    done: 'text-primary'
  },
  overlay: {
    inControl: 'text-white',
    live: 'text-white',
    done: 'text-white'
  }
};
const STATUS_DOT: Record<BrowserStatusTone, Record<BrowserStatus, string>> = {
  surface: {
    inControl: 'bg-accent',
    live: 'bg-success-inverted',
    done: 'bg-(--text-color-tertiary)'
  },
  overlay: {
    inControl: 'bg-(--color-purple-300)',
    live: 'bg-(--color-green-400)',
    done: 'bg-(--color-gray-300)'
  }
};
const browserStatus = (interactive: boolean, working: boolean): BrowserStatus => interactive ? 'inControl' : working ? 'live' : 'done';
const BrowserStatusBadge = t0 => {
  const $ = _c(27);
  const {
    status,
    tone: t1,
    className
  } = t0;
  const tone = t1 === undefined ? "surface" : t1;
  const {
    t
  } = useTranslation("copilot");
  let t2;
  if ($[0] !== t) {
    t2 = t(_temp);
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp2);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp3);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      inControl: t2,
      live: t3,
      done: t4
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const label = t5[status];
  const t6 = STATUS_TEXT[tone][status];
  let t7;
  if ($[10] !== className || $[11] !== t6) {
    t7 = cx("flex items-center gap-1.5 shrink-0 text-caption-4", t6, className);
    $[10] = className;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== status || $[14] !== tone) {
    t8 = status !== "done" && <span className={cx("absolute inset-0 rounded-full opacity-60 motion-safe:animate-ping [animation-duration:2s]", STATUS_DOT[tone][status])} />;
    $[13] = status;
    $[14] = tone;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = STATUS_DOT[tone][status];
  let t10;
  if ($[16] !== t9) {
    t10 = cx("relative size-1.5 rounded-full", t9);
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <span className={t10} />;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t8) {
    t12 = <span aria-hidden={true} className="relative flex size-1.5 shrink-0">{t8}{t11}</span>;
    $[20] = t11;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== label || $[24] !== t12 || $[25] !== t7) {
    t13 = <span className={t7}>{t12}{label}</span>;
    $[23] = label;
    $[24] = t12;
    $[25] = t7;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
export { type BrowserStatus, BrowserStatusBadge, browserStatus };
function _temp($) {
  return $.chat.browser.ask.inControl;
}
function _temp2($_0) {
  return $_0.chat.browser.live;
}
function _temp3($_1) {
  return $_1.chat.browser.done;
}